// extracted by mini-css-extract-plugin
module.exports = {"link-overlay":"CardLinkOverlay_link-overlay__Wrmo7"};